<template>
  <div>
    <div class="about-box">
      <img :src="imgUrl + 'backround-build.png'" alt="" />
      <div class="about-desc">
        <div class="title">私たちについて</div>
        <div class="line"></div>
        <div class="text">日本のTikTok電商運営代行分野で業界の<br />リ-ディングカンパニ-となり</div>
      </div>
    </div>
    <div class="summary-box">
      <div class="title">会社概要</div>
      <div class="desc">
        途陽国際株式会社は東京・浅草橋に設立され、豊富なローカライズ運営経験と越境ECリソースを活かし、TikTok公式
        認定TSPサービスプロバイダーとして成長しました。ショート動画、ライブ配信、インフルエンサーマーケティング、
        広告運用など、フルファネルのECソリューションを提供し、ロサンゼルスと日本に計100名以上のローカルチームを擁
        し、40以上のライブ配信スタジオを運営しております。2024年第4四半期には、ブラックフライデー期間中、ライブ配
        信とショート動画の両分野で唯一当社が公式パートナーとして各ブランドの販売促進を支援いたしました。MCN/
        キャップ契約を結んだインフルエンサーは1,000人以上にのぼり、そのプライベートコミュニティの総メンバー数
        は300人を超えております。
      </div>
    </div>
    <div class="service-box">
      <div class="title">
        <img class="tik" :src="imgUrl + 'tiktok-white.png'" />
        <div class="text">
          TikTokマーケティング4大サービス
        </div>
      </div>
      <div class="service-section">
        <div class="service-grid">
          <div
            class="service-item"
            v-for="(item, index) in serviceList"
            :key="index"
            :style="{ '--animation-delay': `${index * 0.2}s` }"
          >
            <img
              :src="item.image"
              :alt="item.title"
              class="item-img"
              loading="lazy"
              @load="imgLoaded = true"
              :class="{ 'img-loaded': imgLoaded }"
            />
            <div class="item-content">
              <div class="item-title flex">
                <div class="num">{{ index + 1 }}.</div>
                <div class="title-text">{{ item.title }}</div>
              </div>
              <ul class="item-features">
                <li v-for="(feature, idx) in item.features" :key="idx" class="feature-item">
                  •{{ feature }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <relation />
  </div>
</template>
<script>
import Relation from '@/components/Moudle/Index/Relation.vue'

export default {
  name: 'Navbar',
  components: { Relation },
  data() {
    return {
      imgUrl: process.env.VUE_APP_FILE_URL,
      serviceList: [
        {
          image: process.env.VUE_APP_FILE_URL + 'casestudy-01.png',
          title: 'ローカルインフルエンサー活用',
          features: [
            'インフルエンサーを活用したショット動画マーケティング',
            '開閉先および育成',
            'インフルエンサー向けライブ配信トレーニング・マネジメント'
          ]
        },
        {
          image: process.env.VUE_APP_FILE_URL + 'casestudy-02.png',
          title: 'ショット動画制作',
          features: [
            'ローカルメディアクリエイターの運営',
            '社内専門撮影チーム',
            '豊富な制作リソースを持つディレクター・制作チーム'
          ]
        },
        {
          image: process.env.VUE_APP_FILE_URL + 'casestudy-03.png',
          title: 'ローカルライブ配信',
          features: [
            'LIVE配信機器の設置・運用',
            '商品マーケティング戦略的管理',
            'リアルタイムキーワード最適化と配信者トレーニング',
            'パフォーマンス分析と配信運営研修'
          ]
        },
        {
          image: process.env.VUE_APP_FILE_URL + 'casestudy-04.png',
          title: '広告代理サービス',
          features: [
            '無料アカウント開設・チャージ代行',
            '専門的な広告運用代行サービス',
            'ROAS重視のセントコントロール配信'
          ]
        }
      ],
      activeIndex: -1,
      imgLoaded: false
    }
  },
  methods: {
    // 移动端触摸开始
    handleTouchStart(index) {
      this.activeIndex = index
    },
    // 移动端触摸结束
    handleTouchEnd() {
      setTimeout(() => {
        this.activeIndex = -1
      }, 500)
    }
  }
}
</script>
<style scoped lang="scss">
.about-box {
  position: relative;
  img {
    width: 100%;
  }
  .about-desc {
    position: absolute;
    top: 0;
    left: 80px;
    color: #fff;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .title {
      font-size: 96px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 4.8px;
      opacity: 0;
      transform: scale(0.95);
      animation: titlePopIn 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;

      @keyframes titlePopIn {
        to {
          opacity: 1;
          transform: scale(1);
        }
      }
    }
    .line {
      width: 163.5px;
      height: 2px;
      background: #ffffff;
      margin: 11px 0 31px;
    }
    .text {
      color: #fff;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 40px;
      @media (max-width: $mobile-breakpoint) {
        font-size: 12px;
        line-height: 16px;
      }
    }
  }
}
.summary-box {
  padding: 129px 80px 191px;
  .title {
    color: #303030;
    font-size: 40px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-bottom: 48px;
    @media (max-width: $mobile-breakpoint) {
      font-size: 18px;
    }
  }
  .desc {
    color: #454545;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.8;
    @media (max-width: $mobile-breakpoint) {
      font-size: 14px;
      line-height: 18px;
    }
  }
}
.service-box {
  padding: 0 80px 110px;

  // 仅添加标题动画（不修改原有样式）
  .title {
    position: relative;
    opacity: 0;
    transform: translateY(20px);
    animation: serviceTitleFadeIn 0.8s ease-out forwards 0.3s;

    .tik {
      width: 103px;
      height: 103px;
      display: block;
    }
    .text {
      color: #303030;
      font-size: 40px;
      font-style: normal;
      font-weight: 500;
      line-height: 43.2px; /* 123.429% */
      position: absolute;
      bottom: 0;
      left: 72px;
      @media (max-width: $mobile-breakpoint) {
        font-size: 14px;
      }
    }
  }

  .service-section {
    margin-top: 111px;
    .service-grid {
      display: flex;
      flex-wrap: wrap;
      gap: 25px;
      .service-item {
        width: calc((100% - 75px) / 4);
        @media (max-width: $mobile-breakpoint) {
          width: 100%;
        }

        // 仅添加入场动画（不修改原有样式）
        opacity: 0;
        transform: translateY(30px);
        animation: serviceItemFadeIn 0.8s ease-out forwards;
        animation-delay: var(--animation-delay);

        // 鼠标移入效果 - 核心新增
        transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
        cursor: pointer;

        img {
          width: 100%;
          // 图片加载动画
          opacity: 0;
          transition: all 0.4s ease;

          &.img-loaded {
            opacity: 1;
          }
        }

        .item-content {
          margin-top: 24px;
          .item-title {
            color: #000;
            font-size: 24px;
            font-style: normal;
            font-weight: 400;
            // 标题文字渐入动画
            opacity: 0;
            animation: contentFadeIn 0.6s ease-out forwards;
            animation-delay: calc(var(--animation-delay) + 0.3s);
            @media (max-width: $mobile-breakpoint) {
              font-size: 16px;
            }

            .num {
              transition: color 0.3s ease;
            }

            .title-text {
              transition: color 0.3s ease;
            }
          }
          .item-features {
            color: #454545;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 28px;
            // 列表项逐个渐入
            opacity: 0;
            animation: contentFadeIn 0.6s ease-out forwards;
            animation-delay: calc(var(--animation-delay) + 0.5s);
            @media (max-width: $mobile-breakpoint) {
              line-height: 18px;
              font-size: 14px;
            }

            .feature-item {
              transition: all 0.3s ease;
              transform: translateX(0);
              margin-top: 16px;
              @media (max-width: $mobile-breakpoint) {
                margin-top: 16px;
              }
            }
          }
        }

        // 鼠标移入效果
        &:hover {
          transform: translateY(-8px) scale(1.02);
        }

        // 鼠标移入时图片效果
        &:hover .item-img {
          transform: scale(1.05);
        }

        // 鼠标移入时标题效果
        &:hover .item-title .num {
          color: #0066cc;
        }

        &:hover .item-title .title-text {
          color: #0066cc;
        }

        // 鼠标移入时列表项效果
        &:hover .feature-item {
          color: #333;
          transform: translateX(5px);
        }
      }
    }
  }
}

// 新增动画关键帧（不影响原有样式）
@keyframes serviceTitleFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes serviceItemFadeIn {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes contentFadeIn {
  from {
    opacity: 0;
    transform: translateX(5px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
